import { useEffect } from 'react';
import { isNil } from 'lodash/fp';
import { Outlet, useParams } from 'react-router-dom';
import {
  useGetInventoryQuery,
  useSetDefaultInventoryMutation,
} from '@/api/inventories';

type InventoryUrl = {
  inventoryId: string;
};

const Inventory = () => {
  const params = useParams<InventoryUrl>();
  const inventoryId = Number(params.inventoryId);
  const [setDefaultInventory] = useSetDefaultInventoryMutation();
  const { isSuccess } = useGetInventoryQuery(inventoryId);
  useEffect(() => {
    if (!isNil(inventoryId)) {
      setDefaultInventory(inventoryId);
    }
  }, [setDefaultInventory, inventoryId]);
  return isSuccess ? <Outlet /> : null;
};

export { Inventory };
